var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.trophyIndex <= 2)?_c('span',{style:({color: _vm.indexToTrophyColor() })},[_c('i',{staticClass:"fas fa-trophy"}),_vm._v(" \n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }